import { config } from './environment'

// Determine the environment based on the hostname
const environment = window.location.hostname.includes("qa") || window.location.hostname === "localhost"
  ? "qa"
  : "production";

// Set the appropriate configuration
const REACT_APP_API_HOST = config[environment].REACT_APP_API_HOST;
const REACT_APP_STRIPE_SERVER = config[environment].REACT_APP_STRIPE_SERVER;
const REACT_APP_TOKEN_SERVER = config[environment].REACT_APP_TOKEN_SERVER;
const REACT_APP_RECAPTCHA_SERVER = config[environment].REACT_APP_RECAPTCHA_SERVER;
const REACT_APP_SUBSCRIPTION_RENEW_SERVER = config[environment].REACT_APP_SUBSCRIPTION_RENEW_SERVER;
const REACT_APP_LOGIN_EVENT_SERVER = config[environment].REACT_APP_LOGIN_EVENT_SERVER;

export const editBillingURL = REACT_APP_STRIPE_SERVER;
export const newTokenURL = REACT_APP_TOKEN_SERVER;
export const recaptchaGoogle = REACT_APP_RECAPTCHA_SERVER;
export const subscriptionRenewURL = REACT_APP_SUBSCRIPTION_RENEW_SERVER;
export const loginEventURL = REACT_APP_LOGIN_EVENT_SERVER;

export const endpoints = {
  // API back end DF
  auth: "/auth",
  oauthConsent: "/oauth/consent",
  sendResetPasswordEmail: "/reset-password",
  resetPassword: "/reset-password",
  ValidatePlan: "/plans",
  plans: "/plans",
  signup: "/signup",
  account: "/account",
  people: "/people/search",
  peoplePaginate: "/people/paginate",
  propertyData: "/properties/search",
  propertyDataPaginate: "/properties/paginate",
  businessData: "/businesses/search",
  businessDataPaginated: "/businesses/paginate",
  product: "/products/search",
  productPaginate: "/products/paginate",
  downloads: "/downloads",
  updateAccount: "/account",
  updateAccountPlan: "/account",
  postman: "/postman",
  views: "/views",
  propertyById: "/properties/:record_id",
  defaultViews: "default-views",
  subscriptionRenew: '/subscription-renew-date',
};
export const API_HOST = REACT_APP_API_HOST;
// node-datafiniti-api's OAuth routes (/authorize, /token, /oauth/consent,
// /.well-known/...) are mounted at the API's true origin root, not under the
// versioned /v4 prefix API_HOST carries in production (QA's API_HOST has no
// /v4 to begin with, which is why this only broke in production).
export const API_ROOT_HOST = new URL(REACT_APP_API_HOST).origin;
